import * as React from "react";
import type { SVGProps } from "react";
const SvgWindow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2c-4.34 0-8 3.66-8 8v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-4.34-3.66-8-8-8m6 8v2h-5V4.09c2.8.49 5 2.99 5 5.91m-7-5.91V12H6v-2c0-2.91 2.2-5.41 5-5.91M6 14h5v6H6zm7 6v-6h5v6z"
    />
  </svg>
);
export default SvgWindow;
